import { AttributionBasis } from "@gen/tracker/v1/analytics_pb";
import type { ConversionBasis } from "@/lib/period";

/** The Top bar's «Конверсии по» as the wire enum. */
export function basisToProto(basis: ConversionBasis): AttributionBasis {
  switch (basis) {
    case "click":
      return AttributionBasis.CLICK_TIME;
    case "conv":
      return AttributionBasis.CONVERSION_TIME;
    default:
      return AttributionBasis.LEAD_TIME;
  }
}
